import React from "react";
import { Col, Container, Row } from "reactstrap";

function AwardsPage() {
  // const size = document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024 ? true : false;
  return (
    <>
      <div
        style={{
          overflow: "hidden",
          background: "transparent",
        }}
        className="section pb-2"
      >
        <Container fluid>
          <Container>
            <Row>
              <Col lg={6} className={``}>
                <h3 className=" text-700 text-white">
                  Celebrating Excellence in Finance and Innovation: Finnovex Middle East Awards 2025
                </h3>
                <h4 className=" text-700 text-white">
                  At <b>Exibex</b>, we take pride in recognizing the visionaries, disruptors, and
                  trailblazers transforming the financial landscape. The Finnovex Middle East Awards
                  2025 will celebrate outstanding achievements that are driving innovation, digital
                  evolution, and sustainable growth across the industry.
                  <br />
                  <br />
                  These prestigious awards go beyond recognition—they honor resilience, foresight,
                  and a relentless commitment to reimagining finance. They shine a spotlight on
                  leaders and institutions setting new benchmarks and inspiring the next wave of
                  transformation.
                  <br />
                  <br />
                  With great pride, we applaud those shaping the future of finance through bold
                  ideas, collaborative spirit, and technology-powered progress.
                </h4>
                <br />
              </Col>
              <Col lg={6} className={`mb-3 `}>
                <img
                  src={require("assets/images/awards/DSC08918.jpg")}
                  width="100%"
                  alt="awards"
                  style={{
                    borderRight: "10px solid #c0dea7",
                    borderTop: "10px solid #c0dea7",
                  }}
                />
              </Col>

              {content.map((data, index) => (
                <Col lg={3} key={index} className="stat-div border">
                  <div className="d-flex align-items-center" style={{ minHeight: "125px" }}>
                    <h5 className="text-700 mt-0 text-white">{data}</h5>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </Container>
      </div>
    </>
  );
}

export default AwardsPage;

const content = [
  "Excellence in Mobile Banking",
  "Excellence in Digital Banking",
  "Excellence in Fintech",
  "Excellence in Payments",
  "Excellence in Cybersecurity",
  "Excellence in Customer Experience Enhancement",
  "Excellence in InsurTech",
  "Excellence in Open Banking",
  "Excellence in Cloud Banking",
  "Outstanding Contribution to Financial Inclusion Initiative",
  "Outstanding Contribution to Strategic National Development Initiatives",
  "Outstanding Contribution to Fintech Initiatives",
  "Finnovator of the Year, Middle East",
  "Influencer of the Year, Middle East",
  "Financial Women Trailblazer of the Year",
  "CEO of the Year",
  "COO of the Year",
  "CDO of the Year",
  "CIO of the Year",
  "CTO of the Year",
  "CFO of the Year",
  "CISO of the Year",
];
